import { NgModule } from '@angular/core';
import { OutreachEmailContentFormComponent } from './components/outreach-email-content-form/outreach-email-content-form.component';
import { OutreachEmailComponent } from './components/outreach-email/outreach-email.component';

@NgModule({
  imports: [OutreachEmailComponent, OutreachEmailContentFormComponent],
  exports: [OutreachEmailComponent, OutreachEmailContentFormComponent],
})
export class OutreachEmailModule {}
